import { render, staticRenderFns } from "./GenericDisplay.vue?vue&type=template&id=24e6876e"
import script from "./GenericDisplay.vue?vue&type=script&lang=js"
export * from "./GenericDisplay.vue?vue&type=script&lang=js"
import style0 from "./GenericDisplay.vue?vue&type=style&index=0&id=24e6876e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports